import { useAppToast } from "@ui-seeker/app"
import { getSubmit, postSubmit } from "@ui-seeker/utils"

import { commonFiltersValue, favFilterSelected, setCommonFilters, loadedFavFilters } from "@signals"
import { favFiltersData } from "../@signals"
import { WEBBACK_V2_API } from "@constants"
import { useSearchParams } from 'react-router-dom'
import { track } from "@analytics"


export default function useFavFilterModal() {

    const { showToast } = useAppToast()
    const [ searchParams ] = useSearchParams()

    const getFavouriteFilters = (dashboardKey, setFilterSelected=false, isOpenFavModal=false) => postSubmit(`${WEBBACK_V2_API}/master-data/fav-filter/list`, {
        dashboardKey: dashboardKey,
    }).then(res => {
		favFiltersData.value = res
        if (!!favFiltersData.value.length && !searchParams.get('sp') && !isOpenFavModal) {
            const preferenceFilters = favFiltersData.value.filter( filter => filter.defaultFilter === true)
            favFilterSelected.value = !!preferenceFilters.length ? preferenceFilters[0].value : favFiltersData.value[0].value
            setCommonFilters(favFilterSelected.value)
        } else {
            favFilterSelected.value = null
        }
        loadedFavFilters.value = true
	})

    const deleteFavGroupFilter = filterID => showToast.promise(postSubmit(`${WEBBACK_V2_API}/master-data/fav-filter/delete`, { filterID: filterID }).then(res => {
		favFiltersData.value = favFiltersData.value.filter(row => row.filterID != res.filterID)
	}),{
        error: 'Error',
        success: `The group has been successfully deleted.`,
    })

    const insertFavGroupFilter = (name, existingFilterID) => {
        const handleSubmit = () => {
            showToast.promise(postSubmit(`${WEBBACK_V2_API}/master-data/fav-filter/insert`, {
                name: name,
                overwrite: existingFilterID,
                filter: commonFiltersValue.peek()
            }).then(res => {
                // The filter's name is typed by the user, so only the fact and the shape are sent.
                track('filters_saved', { overwrite: !!existingFilterID })
                favFiltersData.value = updateFavFiltersData(res, existingFilterID)
            }), {
                error: 'Error',
                success: `Group filter successfully created.`,
            })
        }

        if (!!existingFilterID) {
            return showToast.confirm(`Theres another filter with the same name, you want to overwrite it?`, {
                onSubmit: () => handleSubmit()
            })
        }
        return handleSubmit()
    }

    const updateFavFiltersData = (row, existingFilterID) => {
        if (existingFilterID) {
            return favFiltersData.value.map(filter => filter.filterID === existingFilterID ? row : filter)
        }
        return [...favFiltersData.value, row]
    }

    const setFilterDefaultInDashboard = (dashboardKey, filterID, updateSelected=false) => showToast.promise(postSubmit(`${WEBBACK_V2_API}/master-data/fav-filter/filter-default`, {
        dashboardKey: dashboardKey,
        filterID: filterID
    }).then(res => {
        favFiltersData.value = [...res.allData]
        if (updateSelected) {
            const actualID = filterID
            favFilterSelected.value = favFiltersData.value.find(f => f.filterID === actualID).value
        }
    }), {
        success: `Default Dashboard Filter Updated.`,
    })

    return {
        getFavouriteFilters,
        deleteFavGroupFilter,
        insertFavGroupFilter,
        setFilterDefaultInDashboard
    }
}